export default __webpack_public_path__ + "6c98e5ce856fed0267c05cd52cd4ba5b.gif";